const MEDAL_SRC =
    'https://content.harstatic.com/media/icons/school-grade-medal.svg';

const BADGE_TITLES: Record<string, string> = {
    cad_math: 'Maths Distinction',
    cad_progress: 'Progress Distinction',
    cad_read: 'Read/ELA Distinction',
    cad_scie: 'Science Distinction',
    cad_soci: 'Social Distinction',
    cad_gap: 'GAP Distinction',
    cad_post: 'Post-Secondary Distinction',
};

export interface SchoolBadgesProps {
    badges: string[];
}

export const SchoolBadges: React.FC<SchoolBadgesProps> = ({ badges }) => (
    <>
        {badges
            .filter(Boolean)
            .map((key) => {
                const title = BADGE_TITLES[key.toLowerCase()];
                if (!title) return null;
                return (
                    <span title={BADGE_TITLES[key]} key={key}>
                        <img
                            src={MEDAL_SRC}
                            alt="Medal"
                            title={title}
                            data-toggle="tooltip"
                            data-placement="top"
                        />
                    </span>
                );
            })}
    </>
);
